/* ───────────────── BLOCKED EMAIL DOMAINS ───────────────── */
const BLOCKED_EMAIL_DOMAINS = [
  "gmail.com","yahoo.com","hotmail.com","outlook.com","live.com","icloud.com",
  "aol.com","protonmail.com","mail.com","zoho.com","yandex.com","gmx.com",
  "rediffmail.com","inbox.com","fastmail.com","tutanota.com","msn.com","me.com",
  "yahoo.in","yahoo.co.in","hotmail.co.uk","windowslive.com","rocketmail.com",
];


/* ───────────────── EMAIL VALIDATION ───────────────── */

export const validateEmail = (email) => {
  const trimmed = email.trim().toLowerCase();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  if (!emailRegex.test(trimmed))
    return "Please enter a valid email address.";

  const [localPart, domain] = trimmed.split("@");

  if (!localPart || localPart.length < 2)
    return "Please enter a valid organisation email address.";

  if (!domain || domain.split(".").length < 2)
    return "Please enter a valid organisation email domain.";

  if (BLOCKED_EMAIL_DOMAINS.includes(domain))
    return "Personal emails (Gmail, Yahoo, Outlook etc.) are not allowed. Please use your work email.";

  const domainParts = domain.split(".");

  if (domainParts.some((p) => p.length < 2))
    return "Please enter a valid organisation email address.";

  if (/^\d+$/.test(domainParts[0]))
    return "Please enter a valid organisation email address.";

  return null;
};


/* ───────────────── PHONE VALIDATION ───────────────── */

export const validatePhone = (phone) => {
  const phoneRegex = /^[6-9]\d{9}$/;

  if (!phoneRegex.test(phone))
    return "Please enter a valid 10-digit mobile number";

  return null;
};


/* ───────────────── OUTLETS VALIDATION ───────────────── */

export const validateOutlets = (value) => {
  const n = parseInt(value.trim());

  if (isNaN(n) || !Number.isInteger(n))
    return "Please enter a valid whole number (e.g. 5).";

  if (n < 1)
    return "Number of outlets must be at least 1.";

  if (n > 10000)
    return "Please enter a realistic number of outlets.";

  return null;
};


/* ───────────────── ORGANISATION NAME ───────────────── */

export const validateOrgName = (value) => {
  const t = value.trim();

  if (t.length < 2)
    return "Organisation name must be at least 2 characters.";

  if (!/[a-zA-Z]/.test(t))
    return "Please enter a valid organisation name.";

  if (/^[^a-zA-Z0-9]/.test(t))
    return "Organisation name must start with a letter or number.";

  return null;
};


/* ───────────────── PERSON NAME ───────────────── */

export const validatePersonName = (value) => {
  const t = value.trim();

  if (t.length < 2)
    return "Name must be at least 2 characters.";

  if (!/^[a-zA-Z\s'-.]+$/.test(t))
    return "Name should only contain letters, spaces, hyphens, apostrophes, or periods.";

  return null;
};


/* ───────────────── USERNAME ───────────────── */

export const validateUsername = (value) => {
  const t = value.trim();

  if (t.length < 3)
    return "Username must be at least 3 characters.";

  // if (!/^[a-zA-Z0-9_]+$/.test(t))
  //   return "Username can only contain letters, numbers, and underscores.";

  return null;
};


/* ───────────────── PASSWORD ───────────────── */

export const validatePassword = (value) => {
  if (value.length < 6)
    return "Password must be at least 6 characters.";

  return null;
};


/* ───────────────── LOCATION ───────────────── */

export const validateLocation = (value) => {
  const t = value.trim();

  if (t.length < 2)
    return "Please enter a valid location.";

  return null;
};